<template>
  <div class="content-wrapper">
    <SidebarFilters
      :isSearching="isLoadingData"
      :inputsAvaliables="['npsOptions', 'npsMode', 'startMode', 'feelingMode']"
      @search="search"
    />
    <div class="card">
      <div class="card-header d-flex align-items-center py-0">
        <h4 class="py-3 mb-0">Relatório Geral</h4>
      </div>
      <div class="card-body">
        <div id="no-content" v-if="data == null && isLoadingData == false">
          <h6 class="text-center mb-0">
            Selecione um filtro e clique em buscar
          </h6>
        </div>
        <LoadingData v-else-if="isLoadingData" />
        <div v-else>
          <div class="row">
            <div v-if="data.nps.raw.length > 0" class="col-md-12 mb-3">
              <NpsCard :nps="data.nps" />
            </div>
            <div v-else class="col-md-12 mb-3">
              <p class="text-center">
                Não há dados de NPS para os filtros aplicados.
              </p>
              <hr />
            </div>
            <div
              v-if="data.answerTextArea.data.length > 0"
              class="col-md-12 mb-3"
            >
              <AnswerText :data="data.answerTextArea" />
            </div>
            <div v-else class="col-md-12 mb-3">
              <p class="text-center">
                Não há dados de resposta aberta para os filtros aplicados.
              </p>
              <hr />
            </div>
            <div v-if="data.likert.data.length > 0" class="col-md-12 mb-3">
              <Likert :data="data.likert" />
            </div>
            <div v-else class="col-md-12 mb-3 d-none">
              <p class="text-center">
                Não há dados de Likert para os filtros aplicados.
              </p>
              <hr />
            </div>
            <div
              v-if="data.satisfaction.data.length > 0"
              class="col-md-12 mb-3"
            >
              <Satisfaction :data="data.satisfaction" />
            </div>
            <div v-else class="col-md-12 mb-3 d-none">
              <p class="text-center">
                Não há dados de satisfação para os filtros aplicados.
              </p>
              <hr />
            </div>
            <div v-if="data.stars.data.length > 0" class="col-md-12 mb-3">
              <Stars :data="data.stars" />
            </div>
            <div v-else class="col-md-12 mb-3">
              <p class="text-center">
                Não há dados de Likert para os filtros aplicados.
              </p>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import SidebarFilters from '@/components/reports/globals/SidebarFilters.vue'
import NpsCard from '@/components/reports/generals/NpsCard.vue'
import AnswerText from '@/components/reports/generals/AnswerText.vue'
import Likert from '@/components/reports/generals/Likert.vue'
import Satisfaction from '@/components/reports/generals/Satisfaction.vue'
import Stars from '@/components/reports/generals/Stars.vue'

export default {
  name: 'ReportGenerals',

  components: {
    LoadingData,
    SidebarFilters,
    NpsCard,
    AnswerText,
    Likert,
    Satisfaction,
    Stars,
  },

  data() {
    return {
      filters: {
        sendStartDate: null,
        sendEndDate: null,
      },
      data: null,
      isLoadingData: false,
    }
  },

  methods: {
    search(filters) {
      this.filters = filters
      this.searchGeneralReport()
    },

    async searchGeneralReport() {
      try {
        this.isLoadingData = true
        // Retira dos filtros os campos que estão vazios
        Object.keys(this.filters).forEach(
          (key) => this.filters[key] == null && delete this.filters[key],
        )
        this.data = await this.$store.dispatch(
          'searchGeneralReport',
          this.filters,
        )
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
}
</script>
